const scheduleServiceModal = {
  title: 'Schedule Service',
  scheduleTo: 'Schedule for',
  scheduledDate: 'Scheduled Date',
  schedule: 'Schedule',
  cancel: 'Cancel',
};

export default scheduleServiceModal;
